import React, { useEffect, useState } from 'react';
import { Card, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import Company from './AddCompany';
import { Link } from 'react-router-dom';
import { More } from '@material-ui/icons';
import CompanyItem from './CompanyItem';
import SnackbarToast from '../../components/toasts/SnackbarToast';
import ENDPOINT from '../../context/EndPoint';
import axios from 'axios';
import SecurityHeaders from '../../context/SecurityHeaders';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';
import { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'



const Company1 = () => {
  const dispatch = useDispatch()
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeModal, setActiveModal] = useState(null);
      const { rowsPerPage } = useActionsContext();
          const {user} = useContext(AuthContext)
       




  const getCompanies = async () => {
    try {
      // Dispatch a loading action
      dispatch({ type: 'LOADING' });
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("limit", rowsPerPage);
  
      const response = await axios.post(ENDPOINT + "get-companies.php", formData, SecurityHeaders);
  
      if (response) {
        if (response.data.status === "success") {
          // Dispatch a success action with the fetched companies
          dispatch({ type: 'DONE_LOADING'});
  
          setCompanies(response.data.data);
        } else {
          // Dispatch a failure action with an error message
          dispatch({ type: 'ERROR', payload: "Error fetching data" });
  
        }
        setLoading(false);
      }
    } catch (error) {
      // Dispatch a failure action with the error message
      dispatch({ type: 'ERROR', payload: error.message });
  
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
   getCompanies()
  }, [rowsPerPage]);

  
  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''

  });


  return (
    <Container className="mt-5">
      {/* Title Section */}
      <div className="text-center">
        <h2 className="fw-bold">Top Companies</h2>
      </div>





      <div>
        <Link
          to={'/add-company'}
          className="ms-2 nav-link text-black"
        >
          <a className='bg-success p-3 rounded rounded-3' >+ Add Company</a>


        </Link>
      
      </div>
<SnackbarToast open={open} handleClose={()=>setOpen({...open,open:false})}/>


      {/* Show Loading State */}
      {loading ? (
        <div className="text-center mt-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <Row className="mt-3 g-4 justify-content-center">
          {companies.map((company, index) => (

<CompanyItem key={index} company={company} setOpen={setOpen} getCompanies={getCompanies}/>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Company1;
